import { baseUrl } from "@/Base_url";
import axiosInstance from "@/utils/axios";

// ==================== ADMIN APIs ====================

 // *-- Staff Managemnet Api --*

 export const listStaff = async (search = '',role, page) => {
    const params = {};
    if (search && search.trim()) {
      params.search = search.trim();
    }
    if(role){
      params.role = role;
    }
    const response = await axiosInstance.get(`/api/staff?page=${page}`, { params });
    return response.data;
 }

 export const addStaff = async (payload) => {
    const response = await axiosInstance.post('/api/staff', payload);
    return response.data;
 }

 

 export const updateStaff = async (id,payload) => {
    const response = await axiosInstance.patch(`/api/staff/${id}`,payload);
    return response.data;
 }

 export const actionStaff = async (id) => {
    const response = await axiosInstance.get(`/api/staff/status/${id}`);
    return response.data;
 }

 export const staffpermlist = async () => {
    const response = await axiosInstance.get(`/api/doctor/permissions`);
    return response.data;
 }

 export const showstaffdata = async (id) => {
    const response = await axiosInstance.get(`/api/staff/${id}`);
    return response.data;
  };
  

 // *-- Patient Managemnet Api --*

   export const addPatient = async (payload) => {
     const response = await axiosInstance.post(`/api/patients`, payload)
     return response.data;
   }

   export const listPatient = async (search = "", page , from_date , to_date , is_active) => {
      const params = {}
      if(search && search.trim()){
        params.search = search.trim();
      }
      if(from_date && to_date){
        params.from_date = from_date;
        params.to_date = to_date;
      }
      if(is_active !== undefined){
        params.is_active = is_active;
      }
     const response = await axiosInstance.get(`/api/patients?page=${page}`, {params})
     return response.data;
   }

   export const patientProfile = async (id) => {
      const response = await axiosInstance.get(`/api/patient-profiles/${id}`)
      return response.data;
   }

   export const consentTemplates = async () => {
    const response = await axiosInstance.get(`/api/consent-types`)
    return response.data;
   }

   export const updatePatient = async ({id, payload}) => {
    const response = await axiosInstance.patch(`/api/patients/${id}`, payload)
    return response.data;
   }

   export const showPatient = async (id) => {
    const response = await axiosInstance.get(`/api/patients/${id}`)
    return response.data;
   }

  export const patientStatus = async (id) => {
  const response = await axiosInstance.get(`/api/patient/status/${id}`);
  return response.data;
};


   // *-- Capture Photo Api --*

    export const patientlist = async (params = {}) => {
      const response = await axiosInstance.get(`/api/patients-list`, { params })
      return response.data;
    }

    export const visitTypes = async () => {
      const response = await axiosInstance.get(`/api/visit-types`)
      return response.data;
    }

    export const sendCapturePhoto = async (patientId, formDataPayload) => {
      const response = await axiosInstance.post(`/api/patients/${patientId}/treatment-photos`, formDataPayload)
      return response.data;
    }

 // *-- Dashboard Api --* 

  export const AdmindashboardApi = async() => {
   const response = await axiosInstance.get(`/api/admin/dashboard`)
   return response.data;
  }

  // *-- Gallery Api --*

  
export const allphotos = async ({ pageParam = 1, params }) => {
  const response = await axiosInstance.get(
    `/api/patient/all-gallary-photos`,
    {
      params: {
        page: pageParam,
        ...params,
      },
    }
  );

  return response.data.data; 
};


  export const detailphotodata = async (photoId, patientId) => {
    // Use patient_id in path and photo_id as query parameter
    const url = patientId 
      ? `/api/patient/gallary-photos/${patientId}?photo_id=${photoId}`
      : `/api/patient/gallary-photos/${photoId}?photo_id=${photoId}`;
    const response = await axiosInstance.get(url);
    return response.data;
  }

  export const updategallery = async (payload) => {
    const response = await axiosInstance.post(`/api/patient/gallary-photos-update`, payload);
  }

  // *-- Before After Api --*

  export const beforeafter = async(payload) =>{
   const response = await axiosInstance.post(`/api/patients/create-before-after-collages`, payload);
   return response.data;
  }

  // *-- Collage Api --*

  export const createMultiPhotoCollage = async(payload) =>{
    const response = await axiosInstance.post(`/api/patients/create-collages`, payload);
    return response.data;
  }



  // *-- Delete Api --*

export const deleteApi = async ({ id, type }) => {
  const formData = new FormData();
  formData.append('type', type);
  formData.append('id', id);

  const response = await axiosInstance.post(
    `/api/patient/delete-gallary-photos/${id}`,
    formData
  );

  return response.data;
};
